import TEXTS from '../controller/TextVariables';
import ToggleSwitch from './ToggleSwitch';
import { useContext, useState, memo, useEffect } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { Tooltip, StandardTooltipWindow } from './Tooltip';
import MapContext from '../controller/MapProvider';

const CensusToggle = (props) => {
    const { tract, setSelectedTract, censusEnabled, tab } = useContext(InterfaceContext);
    const { setZoom, setWait } = useContext(MapContext);
    const { label, tooltip, disabled: disabled, helpText } = TEXTS.controls.data_level;
    // const [enabled, setEnabled] = useState(censusEnabled);
    const id = 'census-select';
    const onChange = (val) => {
        setSelectedTract(val); //set the tract_level variable
    };
    const options = [
        { label: 'Counties', value: 'county' },
        { label: 'Census Tracts', value: 'census' }
    ];
    const jumpToCensus = () => {
        setWait(true);
        setZoom(8);
        onChange(options[1].value);
    };
    const enabled = censusEnabled || tab.slug === 'data';
    const helpTexts = helpText.split('**');

    return (
        <div id="geo-unit-select" className="census-select field thin">
            <Tooltip id={id} tooltip={true} window={<StandardTooltipWindow id={id} text={enabled ? tooltip : disabled} />}>
                <label id={'label_tract_level'} className={!enabled ? 'disabled' : ''} htmlFor={'tract_level'}>
                    {label}
                </label>
                <ToggleSwitch id="tract_level" onChange={onChange} disabled={!enabled} options={options} selected={tract} />
            </Tooltip>
            {tab.slug === 'map' && (
                <p className="helpText">
                    {helpTexts.length > 1 && helpTexts[0]}
                    <a name="jumpZoom" className="jumpZoom" onClick={jumpToCensus}>
                        {helpTexts.length === 1 ? helpTexts[0] : helpTexts[1]}
                    </a>
                    {helpTexts.length > 2 && helpTexts[2]}
                </p>
            )}
        </div>
    );
};

export default memo(CensusToggle);
